import React from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AgentN8nConnectionPanel({
  n8nWebhookUrl,
  setN8nWebhookUrl,
  n8nHeadersJson,
  setN8nHeadersJson,
  readOnly,
}) {
  const { t } = useTranslation("settings");

  return (
    <Stack spacing={2}>
      <TextField
        label={t("agentsListPage.formN8nWebhookLabel")}
        value={n8nWebhookUrl}
        onChange={(e) => setN8nWebhookUrl(e.target.value)}
        fullWidth
        size="small"
        required
        placeholder="https://seu-n8n.com/webhook/xpro-atendimento"
        helperText={t("agentsListPage.formN8nWebhookHelper")}
        inputProps={{ readOnly }}
      />
      <TextField
        label={t("agentsListPage.formN8nHeadersLabel")}
        value={n8nHeadersJson}
        onChange={(e) => setN8nHeadersJson(e.target.value)}
        multiline
        rows={4}
        fullWidth
        size="small"
        placeholder={'{\n  "X-API-KEY": "seu-token-aqui"\n}'}
        helperText={t("agentsListPage.formN8nHeadersHelper")}
        inputProps={{ readOnly }}
      />
      <Box sx={{ p: 1.5, borderRadius: 1, bgcolor: "action.hover" }}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          {t("agentsListPage.formN8nSetupTitle")}
        </Typography>
        {[1, 2, 3, 4].map((n) => (
          <Typography key={n} variant="caption" display="block" color="text.secondary">
            {t(`agentsListPage.formN8nSetupStep${n}`)}
          </Typography>
        ))}
        <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
          {t("agentsListPage.formN8nSetupNote")}
        </Typography>
      </Box>
    </Stack>
  );
}
